export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-300-normal.woff2?0a34f21caa5fcc72748d2e80043de45f";